import React, { useState } from "react";
import { toast } from "react-toastify";
import AccountBalanceIcon from "@mui/icons-material/AccountBalance";
import PrintIcon from "@mui/icons-material/Print";

// import JS files
import MuiPagination from "../../../shares/MuiPagination";
import OrderDetails from "./OrderDetails";
import ChangeOrderState from "./ChangeOrderState";
import useFetch from "../../../../context/useFetch";
import PanelFilter from "../../../shares/PanelFilter";
import PanelTable from "../../../shares/PanelTable";
import PanelTemplate from "../../../shares/PanelTemplate";
import MuiButton from "../../../shares/MuiButton";
import { useNavigate } from "react-router-dom";
import AdminPrintReceviedOrderiInfo from "./AdminPrintReceviedOrderiInfo";

const headersList = [
  { colName: "unique_id", name: " سند" },
  { colName: "name", name: "مشتری" },
  { colName: "created_at", name: "تاریخ ثبت سفارش" },
  { colName: "total", name: "وزن" },
  { colName: "details", name: "جزییات سفارش" },
  { colName: "print", name: "چاپ سفارش" },
  { colName: "change_state", name: "تغییر وضعیت سفارش" },
];
const dataKey = ["unique_id", "name", "created_at", "total"];

const mobileHeadersList = [
  { colName: "unique_id", name: " سند" },
  { colName: "name", name: "مشتری" },
  { colName: "created_at", name: "تاریخ ثبت سفارش" },
  { colName: "total", name: "وزن" },
];

const TabOne = (props) => {
  const navigate = useNavigate();
  const [codeFilter, setCodeFilter] = useState(null);
  const [dateFilter, setDateFilter] = useState(null);
  const [storeFilter, setStoreFilter] = useState(null);
  const [isFilterOn, setIsFilterOn] = useState(false);
  const [brandFilter, setBrandFilter] = useState(null);
  const [brandsList, setBrandsList] = useState({ results: [] });
  const [brandPagination, setBrandPagination] = useState({
    current: 1,
    pageSize: 150,
    count: 0,
    next: null,
    previous: null,
  });
  const getBrandsApi = useFetch({
    method: "get",
    url: "Brand_Service",
    trigger: true,
    pagination: brandPagination,
    setter: setBrandsList,
    argFunc: (res) => {},
    errMessage: (mess) => {
      toast.error("خطایی رخ داده است", {
        position: toast.POSITION.TOP_CENTER,
      });
    },
  });
  const filterList = [
    {
      type: "textField",
      label_fa: "سند",
      label_en: "code",
      state: codeFilter,
    },
    {
      type: "select",
      label_fa: "برند",
      label_en: "brand",

      state: brandFilter,
      menuItems: brandsList.results,
      fromApi: true,
    },
    {
      type: "textField",
      label_fa: "نام مشتری",
      label_en: "storeName",
      state: storeFilter,
    },
    {
      type: "datePicker",
      label_fa: "تاریخ ثبت سفارش",
      label_en: "date",
      state: dateFilter,
    },
  ];

  const [paginationPageInfo, setPaginationPageInfo] = useState({
    current: 1,
    pageSize: 30,
    count: 0,
  });

  const [receviedOrdersList, setReceviedOrdersList] = useState({ results: [] });
  const [weightSum, setWeightSum] = useState(0);
  const [weightSumRed, setWeightSumRed] = useState(0);
  const [weightSumGreen, setWeightSumGreen] = useState(0);
  const rowsWeightSum = (res) => {
    let sum = 0;
    let sum_red = 0;
    let sum_green = 0;
    for (let index = 0; index < res.length; index++) {
      sum = sum + parseFloat(res[index].total);
      sum_red = sum_red + parseFloat(res[index].total_red);
      sum_green = sum_green + parseFloat(res[index].total_green);
    }
    setWeightSum(sum);
    setWeightSumRed(sum_red);
    setWeightSumGreen(sum_green);
  };
  const adminGetCustomerReceviedOrderApi = useFetch({
    method: "get",
    url: `Order_Service/admin_get_complete_order`,
    params: { unique_id: codeFilter, date: dateFilter, name: storeFilter },
    trigger: true,
    pagination: paginationPageInfo,
    setter: setReceviedOrdersList,
    argFunc: (res) => {
      setPaginationPageInfo({
        current: res.current,
        pageSize: res.pageSize,
        count: res.count,
        next: res.next,
        previous: res.previous,
      });
      rowsWeightSum(res.results);
    },
    errMessage: (mess) => {
      toast.error("خطایی رخ داده است", {
        position: toast.POSITION.TOP_CENTER,
      });
    },
  });

  const update_filter = (state, e) => {
    if (state == "code") setCodeFilter(e.length > 0 ? e : null);
    if (state == "date") setDateFilter(e.length > 0 ? e : null);
    if (state == "brand") setBrandFilter(e);

    if (state == "storeName") setStoreFilter(e.length > 0 ? e : null);
  };
  const filter = () => {
    if (
      codeFilter !== null ||
      brandFilter !== null ||
      dateFilter !== null ||
      storeFilter !== null
    ) {
      setIsFilterOn(true);
      setReceviedOrdersList({ results: [] });

      adminGetCustomerReceviedOrderApi.reFetch();
    }
  };
  const reset_filter = () => {
    setCodeFilter(null);
    setDateFilter(null);
    setStoreFilter(null);
    setBrandFilter(null);

    adminGetCustomerReceviedOrderApi.reFetch();
  };

  const actionsList = [
    {
      label: "چاپ",
      component: (it) => <AdminPrintReceviedOrderiInfo selectedRow={it} />,
    },
    {
      label: "تغییر وضعیت سفارش",
      component: (it) => (
        <ChangeOrderState
          selectedRow={it}
          adminGetCustomerReceviedOrderApi={adminGetCustomerReceviedOrderApi}
        />
      ),
    },
  ];

  const buttonsList = [
    {
      label: "جزییات سفارش",
      component: (it) => (
        <OrderDetails
          RemoveOrder
          selectedRow={it}
          adminGetCustomerReceviedOrderApi={adminGetCustomerReceviedOrderApi}
        />
      ),
    },
  ];

  const onChangePage = (e, page) => {
    setPaginationPageInfo({
      ...paginationPageInfo,
      current: page,
    });
    setReceviedOrdersList({ results: [] });

    adminGetCustomerReceviedOrderApi.reFetch();
  };

  const handelPrintReport = () => {
    // navigate(
    //   `/print-customers-complete-orders-by-customer/${codeFilter}/${storeFilter}/${dateFilter}`
    // );
    window.open(
      `/print-customers-complete-orders-by-customer/${codeFilter}/${storeFilter}/${dateFilter}`,
      "_blank"
      // "rel=noopener noreferrer"
    );
  };

  return (
    <>
      <PanelFilter
        header="فیلتر سفارش‌ها:"
        list={filterList}
        update_filter={update_filter}
        filter={filter}
        reset_filter={reset_filter}
      />
      <div className="flex justify-end">
        <MuiButton
          onClick={handelPrintReport}
          variant="outlined"
          icon={<PrintIcon />}
          color="primary"
          text="چاپ گزارش"
          margin="mr-2"
        />
      </div>

      <PanelTable
        header="لیست سفارش‌های تحویل داده شده:"
        headers={headersList}
        mobileHeaders={mobileHeadersList}
        data={receviedOrdersList.results}
        dataKey={dataKey}
        buttons={buttonsList}
        actions={actionsList}
        icon={<AccountBalanceIcon />}
      />
      <div className="border py-2 text-sm text-myblue-100 font-bold">
        <div className="flex items-center">
          <div className="mx-6">
            <span className="">جمع وزن کل:</span>
            <span className="mr-4">{weightSum.toFixed(3)} گرم</span>
          </div>
          <div className="mx-6">
            <span className="">جمع تحویلی:</span>
            <span className="mr-4">{weightSumGreen.toFixed(3)} گرم</span>
          </div>
          <div>
            <span className="">جمع کسری:</span>
            <span className="mr-4">{weightSumRed.toFixed(3)} گرم</span>
          </div>
        </div>
      </div>
      <MuiPagination
        onChange={onChangePage}
        count={Math.ceil(
          paginationPageInfo.count / paginationPageInfo.pageSize
        )}
      />
    </>
  );
};

export default TabOne;
